import React, { Component } from 'react';
import './ContractorDocumentsViewer.css';
import PropTypes from 'prop-types';
import DocumentLink from 'components/shared/document/DocumentLink';

class ContractorDocumentsViewer extends Component {
  static propTypes = {
    contractor: PropTypes.object,
  };

  render() {
    const contractor = this.props.contractor;
    return (
      <div className="contractor-documents-viewer">
        <div className="document-title">W9 DOCUMENT</div>
        {contractor.w9_document && (
          <ul className="document-links">
            <li>
              <DocumentLink url={contractor.w9_document.document.url} />
            </li>
          </ul>
        )}
        <div className="document-title">MSA DOCUMENT</div>
        {contractor.msa_document && (
          <ul className="document-links">
            <li>
              <DocumentLink url={contractor.msa_document.document.url} />
            </li>
          </ul>
        )}
      </div>
    );
  }
}

export default ContractorDocumentsViewer;



// WEBPACK FOOTER //
// ./src/components/admin/contractors/ContractorDocumentsViewer.js